export default class ToastManager {
    constructor(options = {}) {
        this.options = Object.assign(Object.assign({}, ToastManager.defaults()), options);
        this.init();
    }
    static defaults() {
        return {
            delay: 5000,
            closeBtn: true,
            status: 'success',
            containerClass: 'toasts',
            itemClass: 'toast',
        };
    }
    init() {
        this.container = document.createElement('div');
        this.container.classList.add(this.options.containerClass || 'toasts');
        document.body.append(this.container);
    }
    destroy() {
        var _a;
        (_a = this.container) === null || _a === void 0 ? void 0 : _a.remove();
    }
    show(text, options = {}) {
        var _a, _b, _c, _d, _e, _f;
        if (!this.container)
            return;
        const status = (_b = (_a = options.status) !== null && _a !== void 0 ? _a : this.options.status) !== null && _b !== void 0 ? _b : 'success';
        const showCloseBtn = (_d = (_c = options.closeBtn) !== null && _c !== void 0 ? _c : this.options.closeBtn) !== null && _d !== void 0 ? _d : true;
        const delay = (_f = (_e = options.delay) !== null && _e !== void 0 ? _e : this.options.delay) !== null && _f !== void 0 ? _f : 0;
        const itemHTML = ToastManager.getItemHTML(text, status, showCloseBtn);
        this.container.insertAdjacentHTML('beforeend', itemHTML);
        const item = this.container.lastElementChild;
        if (item) {
            const closeBtn = item.querySelector(`.${this.options.itemClass}__close-btn`);
            if (closeBtn) {
                closeBtn.addEventListener('click', this.handleCloseBtnClick.bind(this));
            }
            if (delay > 0) {
                setTimeout(() => {
                    this.hideItem(item);
                }, delay);
            }
        }
    }
    handleCloseBtnClick(event) {
        const target = event.target;
        const item = target === null || target === void 0 ? void 0 : target.closest(`.${this.options.itemClass}`);
        if (item)
            this.hideItem(item);
    }
    hideItem(item) {
        if (item && this.container) {
            const closeBtn = item.querySelector(`.${this.options.itemClass}__close-btn`);
            if (closeBtn) {
                closeBtn.removeEventListener('click', this.handleCloseBtnClick.bind(this));
            }
            // item.style.maxHeight = '0px';
            // item.style.opacity = '0';
            item.classList.add('hiding');
            setTimeout(() => {
                item.remove();
            }, 300);
        }
    }
    static getItemHTML(text, status = 'success', showCloseBtn = true) {
        const closeBtnTemplate = `<button class="toast__close-btn" type="button" aria-lable="Закрыть">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon--close" aria-hidden="true">
            <path fill="#D9D9D9" d="M4.414 3l16.97 16.97-1.414 1.415L3 4.415z"></path>
            <path fill="#D9D9D9" d="M3 19.97L19.97 3l1.415 1.415-16.97 16.97z"></path>
            <path fill="#D9D9D9" d="M3 19.97L19.97 3l1.415 1.415-16.97 16.97z"></path>
        </svg>
    </button>`;
        const closeBtn = showCloseBtn ? closeBtnTemplate : '';
        const textStr = text || 'Успешно';
        const statusStr = status || 'success';
        const iconCheck = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="url(#paint0_radial_4420_3470)"/>
      <path d="M19.4986 7.1447C17.5901 6.29434 15.4579 6.08368 13.42 6.54413C11.382 7.00458 9.54748 8.11147 8.19 9.69973C6.83252 11.288 6.02481 13.2725 5.88734 15.3573C5.74986 17.4421 6.29 19.5155 7.42717 21.2683C8.56435 23.021 10.2377 24.3592 12.1975 25.0833C14.1574 25.8073 16.2988 25.8785 18.3024 25.2861C20.306 24.6937 22.0644 23.4695 23.3154 21.7961C24.5664 20.1227 25.2429 18.0895 25.2441 16.0001V15.1821C25.2441 14.7403 24.8859 14.3821 24.4441 14.3821C24.0023 14.3821 23.6441 14.7403 23.6441 15.1821V15.9994C23.6431 17.7437 23.0783 19.441 22.0339 20.8381C20.9895 22.2351 19.5214 23.2572 17.8487 23.7517C16.176 24.2463 14.3882 24.1869 12.752 23.5824C11.1158 22.9779 9.71881 21.8607 8.76942 20.3974C7.82003 18.9341 7.3691 17.2031 7.48387 15.4626C7.59864 13.7221 8.27296 12.0653 9.40628 10.7393C10.5396 9.41331 12.0712 8.4892 13.7726 8.10479C15.474 7.72038 17.2541 7.89625 18.8474 8.60618C19.251 8.78601 19.7239 8.60462 19.9037 8.20104C20.0836 7.79746 19.9022 7.32452 19.4986 7.1447Z" fill="#F2F2F2"/>
      <path d="M25.0095 8.32282C24.6969 8.01055 24.1904 8.01081 23.8781 8.32338L15.5549 16.6549L13.4542 14.5542C13.1418 14.2418 12.6353 14.2418 12.3229 14.5542C12.0105 14.8666 12.0105 15.3732 12.3229 15.6856L14.9895 18.3523C15.1396 18.5023 15.3432 18.5866 15.5554 18.5866C15.7677 18.5865 15.9712 18.5021 16.1212 18.352L25.0101 9.45419C25.3223 9.14161 25.3221 8.63508 25.0095 8.32282Z" fill="#F2F2F2"/>
      <defs>
        <radialGradient id="paint0_radial_4420_3470" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(16 16) rotate(90) scale(16)">
          <stop stop-color="#0C9D6D"/>
          <stop offset="1" stop-color="#55E09B"/>
        </radialGradient>
      </defs>
    </svg>`;
        const iconWarning = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M17.3946 3.01855C17.808 3.2548 18.1506 3.59741 18.3868 4.0108L29.7917 23.9693C30.5224 25.2481 30.0781 26.877 28.7994 27.6077C28.3965 27.8379 27.9405 27.959 27.4764 27.9591H4.66669C3.19394 27.9591 2 26.7651 2 25.2924C2.00001 24.8283 2.12113 24.3722 2.35138 23.9693L13.7562 4.0108C14.4869 2.73212 16.1159 2.28787 17.3946 3.01855ZM16 19.6667C15.0476 19.6667 14.3333 20.3707 14.3333 21.3094C14.3333 22.2907 15.026 22.9947 16 22.9947C16.9524 22.9947 17.6667 22.2907 17.6667 21.3307C17.6667 20.3707 16.9524 19.6667 16 19.6667ZM17.3333 9.33343H14.6667V17.3334H17.3333V9.33343Z" fill="#FF4661"/>
    </svg>`;
        const toastIcon = (statusStr === 'error') ? iconWarning : iconCheck;
        return `<div class="toast toast--${statusStr}">
      ${toastIcon}
      <span class="toast__text">${textStr}</span>
      ${closeBtn}
    </div>`;
    }
}
